var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIsShared = function SvgIsShared(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "is_shared_svg__is_x5F_shared",
    x: 0,
    y: 0,
    viewBox: "0 0 16.096 13.019",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".is_shared_svg__st0{fill:#414a5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.978 3.104-.431-.431-.006-.006a.4.4 0 0 0-.566.006l-2.787 2.782-1.262-1.263-.006-.006a.4.4 0 0 0-.566.006l-.431.431-.006.006a.4.4 0 0 0 .006.566l1.981 1.978a.4.4 0 0 0 .284.12.4.4 0 0 0 .29-.117l3.5-3.5a.404.404 0 0 0 0-.572M5.7 6.509a3.255 3.255 0 1 0-.005 0zm2.278.814h-.429a4.43 4.43 0 0 1-3.707 0h-.425A3.42 3.42 0 0 0 0 10.74v1.06a1.22 1.22 0 0 0 1.22 1.22h8.95a1.22 1.22 0 0 0 1.22-1.22v-1.06a3.42 3.42 0 0 0-3.416-3.417z",
    className: "is_shared_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIsShared);
export default ForwardRef;